<template>
  <div class="container">
    <a-breadcrumb separator=">">
      <a-breadcrumb-item href="" @click.native="() =>$router.push('/')">首页</a-breadcrumb-item>
      <a-breadcrumb-item href="" @click.native="() =>$router.go(-1)">药品查询</a-breadcrumb-item>
      <a-breadcrumb-item>药品详情</a-breadcrumb-item>
    </a-breadcrumb>
    <div class="drug-name">
      <!-- <img src="" alt="" /> -->
      <div class="text">
        <div class="name">{{ queryDetail.drugName }}</div>
        <div class="place">请仔细阅读说明书并在医生的指导下使用</div>
      </div>
    </div>
    <div class="explain">药品说明书</div>
    <div class="explain-content">
      <iframe :src="dataDetail" frameborder="0" class="iframe"></iframe>
    </div>
  </div>
</template>

<script>
import { getDetail,getDetail2 } from '@/api/drug'
export default {
  components: {},
  data() {
    return {
      queryDetail: {},
      dataDetail: ''
    }
  },
  watch: {
    '$route.query': {
      handler(val) {
        const data = JSON.parse(val.data)
        this.queryDetail = data
        this.getData()
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    async getData() {
      const params = {
        ...this.queryDetail
      }
      const { code, data } =this.$route.query.version==2? await getDetail2(params):await getDetail(params)
      if (code == 200) {
        this.dataDetail = data
      }
    },
    toHome() {
      this.$router.push('/')
    }
  }
}
</script>

<style lang="scss" scoped>
.fontColor1 {
  color: #fe695c;
  font-size: 14px;
}

.fontColor {
  color: #8e8e8e;
  font-size: 14px;
}

.fontstyle {
  font-size: 14px;
  cursor: pointer;
}

.center {
  margin-top: 52px;
  text-align: center;

  .inform {
    margin: 12px 0;
  }
}

.flex {
  display: flex;
  justify-content: space-evenly;
}

.container {

  .drug-name {
    padding: 20px 0;
    margin-bottom: 12px;
    display: flex;

    >img {
      width: 80px;
      height: 80px;
      margin-right: 20px;
    }

    .text {
      display: flex;
      flex-direction: column;
      justify-content: center;

      .name {
        font-size: 28px;
        font-weight: 600;
      }

      div {
        padding: 4px 0;
      }
      .place{
        font-size: 14px;
        color: #999;
      }
    }
  }

  .explain {
    margin: 8px 0;
    font-size: 14px;
    width: 100%;
    iframe {
      width: 100%;
    }
  }

  .explain-content {
    padding: 20px;
    border: 1px solid #ebebeb;

    .iframe {
      width: 100%;
      min-height: 980px;
    }
  }
}
</style>
